import $ from 'jquery/src/jquery'
import {pageScroll} from "../helpers";
import PlanMap from "../modules/plan-map";

export default () => {
    const nodeSelectors = {
        section: '[js-map-popup="section"]',
        popup: '[js-map-popup="container"]',
        close: '[js-map-popup="close"]',
        open: '[js-map-popup="open"]',

        slider: '[js-slider="slider"]',
        prev: '[js-slider="prev"]',
        next: '[js-slider="next"]',
        pagination: '[js-slider="pagination"]',
    }

    function init() {

        if (!document.querySelector(nodeSelectors.popup)) {
            return
        }

        $(document).keyup(function(e) {
            if (e.key === "Escape") {
                close()
            }
        })

        $(nodeSelectors.close).on('click', close)
        $(nodeSelectors.open).on('click', open)
    }

    function open() {
        pageScroll(false)
        let target = $(this).data('js-map-popup--target')
        let pinClass = this.getAttribute("data-js-map-popup--pin")
        $(target).removeClass('popup--hidden')
        $(nodeSelectors.open + '[data-js-map-popup--target="'+target+'"]').addClass('active')

        if( pinClass ) {
            // It means clicked element is OUTSIDE of Map element
            let target = document.querySelector(pinClass)
            PlanMap().centerContainerByChild(target)
        } else {
            // It means clicked element is UNDER of Map element
            PlanMap().centerContainerByChild(this)
        }
    }

    function close() {
        pageScroll(true)
        $(nodeSelectors.open).removeClass('active')
        $(nodeSelectors.popup).addClass('popup--hidden')
    }

    return Object.freeze({
        init,
    })
}